import React from 'react';
import ProfileAvatar from 'components/ProfileAvatar';

const NOOP = function() {};

export default function AutoSuggestItem(props) {
    const { item: user, onSelect = NOOP, selected } = props;

    const onMouseDown = function(event) {
        event.stopPropagation();
        onSelect(user);

        return false;
    };

    return (
        <div className={'autosuggest__item' + (selected ? ' selected' : '')} onMouseDown={onMouseDown}>
            <ProfileAvatar user={user}/>
            <span className="profile-nick">{user.nick}</span>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/autosuggest/AutoSuggestItem.js